export const Header = () => <header>Header</header>
